// extracted by mini-css-extract-plugin
export default {"component":"DBrokerDealerPage_component__rskXl","desc":"DBrokerDealerPage_desc__HjpQ2","table":"DBrokerDealerPage_table__DKptX","sideColumn":"DBrokerDealerPage_sideColumn__9VnkM"};